<template>
  <div class="QuestionComponent">
    <p class="question">
      {{ question.question }}
    </p>
    <v-text-field
      v-if="!question.type.needs_options"
      id="id"
      :name="question.question"
      :placeholder="question.placeholder"
      :type="question.type.name.toLowerCase()"
    />
    <p v-else>
      Unsupported Question type: {{ question.type.name }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'QuestionComponent',
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
  .QuestionComponent {
    margin: 1rem 0;
    .question {
      color: rgba(0, 0, 0, 0.6);
      font-weight: bold;
      font-size: 1.3rem;
    }
  }
</style>
